// extracted by mini-css-extract-plugin
module.exports = {"floating":"styles_floating__z0E0P","floatingHidden":"styles_floatingHidden__TRg_V"};